<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/joseph-asamoah.jpg" alt="Joseph Asamoah">
          </figure>
         <div class="finger-print"><img src="@/assets/images/fingerprints/fingerprint-one.svg" alt=""></div>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Joseph Asamoah</h2>
      <p class="job-title">Lecturer</p>

      <p class="profile-statement-interviewer">Tell me a little bit about yourself</p>

      <p>My father is Ghanian, and my mother is Portuguese-Saotomean, so I’m a mix. I am an up-and-coming lecturer who is interested in teaching and explaining concepts to students. I’m interested in things related to occurrences in the world. I’m a doctorate degree holder and have a passion for literature, politics, and science.</p>

      <p class="profile-statement-interviewer">What inspires you within your role?</p>

      <p>Seeing students being happy. Seeing the faces of students when they are taught and really appreciate and understand what you are teaching. When they don't understand, I can help them understand specific topics or subject matters by explaining them. This drives me to do more research and preparation, and this really motivates me within my role.</p>

      <p class="profile-statement-interviewer">What is something about your culture or heritage that you love?</p>

      <p>There are distinctive parts to always respect your elders and always stay humble.</p>

      <p class="profile-statement-interviewer">What does it look like to bring your whole self into work?</p>

      <p>I think you come to work in a professional capacity. You know what you’re supposed to do, and you try to do your work to the best of your ability. As to whether your culture or diverse background comes into play is not something I’ve really thought about or questioned in its entirety if I’m honest. I don’t think me being myself is driven by my personal identity. It’s more driven by my personal drive to work professionally.</p>

      <p class="profile-statement-interviewer">How do you think MMU can best celebrate their BAME students?</p>

      <p>Being someone of African descent, I think you could perhaps project the African voice by inviting lecturers or scholars to deliver a talk about the African perspective. Avoiding topics which are related to slavery, colonialism, or underdevelopment is important because it always evokes negative connotations. However, it would be more appealing to discuss issues related to progressions made in the African sub-continent. In terms of development, things that would propagate blackness in a more positive light. Inviting students and academics to these discussions could help to enlighten others and offer a different perspective.</p>

      <p class="profile-statement-interviewer">What are you most proud of?</p>

      <p>I would say I’m most proud of my two beautiful children and I love to see them grow. You try to live your life as an inspiration to them and you want them to always look up to you as a role model.</p>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  .profile-container {
  flex-direction: row-reverse;
  }

  .profile-portrait-container {
    justify-content: flex-end;

    & figure {
      text-align: right;
    }
  }

  // .profile-statement {
  //   padding-right: 5rem;
  //   // padding-left: 5rem;
  // }

</style>